// 私有化部署配置文件
export default {
  marshotspotUrl: ""
};
